module.exports = __webpack_public_path__ + "img/mclarer.78eab08a.jpg";